module.exports = __webpack_public_path__ + "static/media/payment_new.309efd9b.png";